import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Library from './pages/Library';
import AuthModal from './components/AuthModal';
import './index.css';
import Discover from './pages/Discover';
import Journal from './pages/Journal';
import Onboarding from './components/Onboarding';
import axios from 'axios';
import Profile from './pages/UserProfile';
import Feed from './pages/Feed';
import PublicProfile from './pages/PublicProfile';
import VerifyEmail from './pages/VerifyEmail';
import VerifyPending from './pages/VerifyPending';
import ResetPassword from './pages/ResetPassword';
import Legal from './pages/Legal';
import Admin from './pages/Admin';
import Wishlist from './pages/Wishlist';

function AppContent() {
  const [user, setUser] = useState(null);
  const [authModal, setAuthModal] = useState(null);
  const navigate = useNavigate();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    if (savedToken && savedUser) {
      setUser(JSON.parse(savedUser));
      setToken(savedToken);
    }
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (user && token) {
      checkOnboarding();
    }
  }, [user]);

  const checkOnboarding = async () => {
    if (localStorage.getItem('onboarding_completed') === 'true') return;

    const activeToken = token || localStorage.getItem('token');
    if (!activeToken) return;

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/profile`,
        { headers: { Authorization: `Bearer ${activeToken}` } }
      );
      if (res.data && res.data.profile && res.data.profile.onboarding_completed) {
        localStorage.setItem('onboarding_completed', 'true');
      } else {
        setShowOnboarding(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleAuthSuccess = (userData, userToken) => {
    setUser(userData);
    setToken(userToken);
    localStorage.setItem('token', userToken);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.removeItem('pendingVerificationEmail');
    setAuthModal(null);
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('pendingVerificationEmail');
    localStorage.removeItem('onboarding_completed');
    navigate('/');
  };

  const handleNavigate = (page) => {
    navigate(`/${page}`);
  };

  const handleUsernameChange = (newUsername) => {
    const updatedUser = { ...user, username: newUsername };
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
  };

  return (
    <div className="app">
      <Navbar
        user={user}
        onLogout={handleLogout}
        onSignIn={() => setAuthModal('login')}
        onNavigate={handleNavigate}
      />
      <Routes>
        <Route path="/" element={
          <Home
            user={user}
            onSignIn={() => setAuthModal('login')}
            onSignUp={() => setAuthModal('register')}
            onNavigate={handleNavigate}
            token={localStorage.getItem('token')}
          />
        } />
        <Route path="/library" element={<Library token={localStorage.getItem('token')} />} />
        <Route path="/discover" element={<Discover token={localStorage.getItem('token')} />} />
        <Route path="/journal" element={<Journal token={localStorage.getItem('token')} />} />
        <Route path="/profile" element={
          <Profile
            token={localStorage.getItem('token')}
            onUsernameChange={handleUsernameChange}
          />
        } />
        <Route path="/feed" element={<Feed token={localStorage.getItem('token')} user={user} onNavigate={(path) => navigate(path)} />} />
        <Route path="/u/:username" element={<PublicProfile token={localStorage.getItem('token')} currentUser={user} />} />
        <Route path="/verify-email" element={<VerifyEmail onSuccess={handleAuthSuccess} />} />
        <Route path="/verify-pending" element={<VerifyPending onSuccess={handleAuthSuccess} />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/admin" element={<Admin user={user} token={localStorage.getItem('token')} />} />
        <Route path="/wishlist" element={<Wishlist token={localStorage.getItem('token')} />} />
      </Routes>
      {authModal && (
        <AuthModal
          mode={authModal}
          onClose={() => setAuthModal(null)}
          onSuccess={handleAuthSuccess}
        />
      )}
      {showOnboarding && (
        <Onboarding
          user={user}
          token={token}
          onComplete={() => {
            localStorage.setItem('onboarding_completed', 'true');
            setShowOnboarding(false);
            navigate('/');
          }}
        />
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;